angular.module('zc.projects')

.controller 'GaTagTrackingCtrl', ($scope, Project, currentProject, googleAnalyticsEventLabels) ->
  $scope.project = currentProject
  $scope.googleAnalyticsEventLabels = googleAnalyticsEventLabels

  $scope.save = (project) ->
    Project.update
      projectId: project.id
    ,
      project: _.merge {},
        project,
        google_analytics_event_enable: !$scope.project.google_analytics_event_enable
    .then (updatedProject) ->
      $scope.project = updatedProject

  $scope.$watch 'project.google_analytics_event_action_control_enable', () ->
    if $scope.project.google_analytics_event_action_control_enable
      if !$scope.project.google_analytics_event_action_control
        $scope.project.google_analytics_event_action_control = 'hidden'
    else
      $scope.project.google_analytics_event_action_control = ''



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/initialization/ga_tag_tracking.controller.coffee